module.exports = __webpack_public_path__ + "static/media/me.b8eca7f5.jpg";